export const disabilityTypes = Object.freeze({
  CARROZZINA: 'carrozzina',
  MOTORIA: 'motoria',
  ALTRO: 'altro',
})
export const disabilityServices = Object.freeze({
  CONVENZIONALE: 'convenzionale',
  H: 'h',
})
